import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'INVIT_FOURN',
  title: 'Wie lade ich meine Unterauftragnehmer ein?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Wenn Sie Ihre Nachunternehmer einladen, können Sie auf deren Dokumente auf der Plattform zugreifen, wann immer Sie sie benötigen.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Gehen Sie auf die Registerkarte " Nachunternehmer "'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INVIT_FOURN/DE_INVIT_FOURN_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie oben rechts auf die Schaltfläche "Nachunternehmer hinzufügen".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INVIT_FOURN/DE_INVIT_FOURN_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Wenn er in der Liste erscheint, wird er durch einen einfachen Klick in Ihre Liste der Nachunternehmer aufgenommen.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INVIT_FOURN/DE_INVIT_FOURN_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Wenn Sie Ihren Nachunternehmer nicht finden können, ist er möglicherweise kein Mitglied der Plattform. Fahren Sie daher mit einer Einladung fort, indem Sie das Einladungsformular ausfüllen und dann bestätigen.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INVIT_FOURN/DE_INVIT_FOURN_4.png`
  }]
};
